import SectionHeader from "../shared/SectionHeader";
import { BillingAlert, DocumentAlert } from "../shared/AlertBanner";
import { useUserContext } from "../../hooks/useUserContext";

export default function Summary() {
  const { hasExpiredPaymentMethods, hasUnsignedDocuments } = useUserContext();

  return (
    <div className="tw-space-y-4">
      <SectionHeader title="Summary" />
      {hasExpiredPaymentMethods && <BillingAlert />}
      {hasUnsignedDocuments && <DocumentAlert />}
      <div className="tw-rounded-lg tw-border tw-p-4 tw-bg-white tw-flex tw-flex-col tw-gap-4">
        <p className="tw-text-muted-foreground tw-h-[200px]">
          Summary section is coming soon!
        </p>
      </div>
    </div>
  );
}
